import { render, staticRenderFns } from "./FormProduto.vue?vue&type=template&id=7db5171c&scoped=true"
import script from "./FormProduto.vue?vue&type=script&lang=js"
export * from "./FormProduto.vue?vue&type=script&lang=js"
import style0 from "./FormProduto.vue?vue&type=style&index=0&id=7db5171c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db5171c",
  null
  
)

export default component.exports